import React from "react";
import { TREATMENT_RUNTIME_NOTICE } from "./treatmentUiConstants";
import "./treatmentRuntimeNotice.css";

const noticeFor = (error) => {
  if (Number(error?.status) === 429) {
    return TREATMENT_RUNTIME_NOTICE.rateLimited;
  }
  const code = String(error?.code || error?.rawCode || "").toLowerCase();
  if (code === "runtime_release_integrity_invalid") {
    return TREATMENT_RUNTIME_NOTICE.integrity;
  }
  const identity = `${error?.code || ""} ${error?.message || ""}`.toLowerCase();
  if (identity.includes("expired") || error?.status === 410) {
    return TREATMENT_RUNTIME_NOTICE.expired;
  }
  if (identity.includes("stale") || error?.status === 409) {
    return TREATMENT_RUNTIME_NOTICE.stale;
  }
  if (identity.includes("snapshot") || identity.includes("capability")) {
    return TREATMENT_RUNTIME_NOTICE.snapshot;
  }
  return TREATMENT_RUNTIME_NOTICE.unavailable;
};

export default function TreatmentRuntimeNotice({
  error,
  busy,
  onRetry,
  onStartOver,
}) {
  if (!error) return null;
  const notice = noticeFor(error);
  const retryAfterSeconds = Number(error?.retryAfterSeconds);
  const waitMinutes = Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
    ? Math.ceil(retryAfterSeconds / 60)
    : null;
  const isIntegrityError = (
    String(error?.code || error?.rawCode || "").toLowerCase()
    === "runtime_release_integrity_invalid"
  );
  return (
    <section className="treatment-runtime-notice" role="alert">
      <div className="treatment-runtime-notice-icon" aria-hidden="true">!</div>
      <h2>{notice.title}</h2>
      <p>{notice.description}</p>
      {Number(error?.status) === 429 && waitMinutes && (
        <small>Try again in about {waitMinutes} {waitMinutes === 1 ? "minute" : "minutes"}.</small>
      )}
      {error.message && !isIntegrityError && Number(error?.status) !== 429 && <small>{error.message}</small>}
      <div className="treatment-runtime-notice-actions">
        <button type="button" disabled={busy} onClick={onRetry}>
          {busy ? "Loading…" : notice.action}
        </button>
        {Number(error?.status) !== 429 && error.action?.code === "start_over" && onStartOver && (
          <button type="button" className="treatment-runtime-notice-btn-secondary" disabled={busy} onClick={onStartOver}>
            {error.action.label || "Start over"}
          </button>
        )}
      </div>
    </section>
  );
}
